<template>

  <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
    <el-main>
      <el-card class="box-card">

        <div slot="header" class="clearfix">
          <span>基本資料</span>
          <el-button style="float: right; padding: 2px 0; margin-top: -12px" type="text">
            <el-tag type="success">{{basicForm.status | fmtSignResult }}</el-tag>
          </el-button>
        </div>
        <div>
          <el-form :model="basicForm" ref="basicDataForm" label-width="100px">
            <el-row>
              <el-col :xs="24" :sm="24" :md="8">
                <el-form-item label="填單人" prop="userObj.username" >
                  <el-input readonly v-model="basicForm.userObj.username"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="8">
                <el-form-item label="標題" prop="title">
                  <el-input v-if="canEdit" v-model="basicForm.title" autocomplete="off"></el-input>
                  <el-input v-if="!canEdit" readonly v-model="basicForm.title" autocomplete="off"></el-input>

                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="8">
                <el-form-item label="報表日期" prop="startDate" >
                  <el-date-picker v-if="canEdit"  type="date" placeholder="選擇日期" v-model="basicForm.startDate"></el-date-picker>
                  <el-date-picker v-if="!canEdit" readonly type="date" placeholder="選擇日期" v-model="basicForm.startDate"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </el-main>
  </el-col>

</template>

<script>


export default {
  name: "TaskBasicInfo",
  components: {
    
  },
  props: ['basicForm', 'canEdit'],
  data() {
    return {
      
      

    }
  },
  methods: {

    
    
  },
  mounted() {

    

  }
}
</script>

<style scoped>
.el-main {
  padding: 0;
  margin-bottom: 20px;
}
.el-card__body {
  padding: 0 12px;
}

</style>
